module.exports = new __parcel__URL__("tail_strike.edff5ac5.png").toString();